/* takes of hiding and showing fields/columns in tables */
export const getVisibleFields = (
  groupingFields,
  fieldsForGroupedView,
  defaultFieldObject,
  hiddenFields
) => {
  let finalMappingObject = {
    ...fieldsForGroupedView,
  }
  Object.entries(defaultFieldObject).forEach(([key, value]) => {
    if (!groupingFields.includes(key) && !hiddenFields.includes(key)) {
      finalMappingObject[key] = value
    }
  })
  return finalMappingObject
}

/* takes care of grouping of data */
export const getGroupedData = (data, groupingFields = [], accumulatedFields = [], headingMap) => {
  let outArr = []
  data.forEach((item) => {
    let currentGroup = outArr
    groupingFields.forEach((groupingKey, index) => {
      let groupName = item[groupingKey]?.value
      let currentChild = currentGroup.find((child) => child.name === groupName)
      if (!currentChild) {
        currentChild = {
          key: headingMap[groupingKey],
          name: groupName,
          is_open: false,
          level: index,
          children: [],
          ...accumulatedFields.reduce((acc, cur) => {
            return { ...acc, [cur]: { value: 0 } }
          }, {}),
        }
        currentGroup.push(currentChild)
      }

      accumulatedFields.forEach((it) => {
        currentChild[it].value += Number(item[it]?.value)
        currentChild[it].data_structure = item[it]?.data_structure
        currentChild[it].id = item[it]?.id
      })

      if (index === groupingFields.length - 1) {
        currentChild.children.push(item)
      }
      currentGroup = currentChild.children // Update the current group to the children array
    })
  })
  return outArr
}

/* resolve the ids and return values along with existing pairs  */
const getValue = (id, type, row, listData, keyValuePairs, obj) => {
  if (type === 'list') {
    const itemId = keyValuePairs[id + '__' + row]
    const value = listData.find((it) => it.id === itemId)
    return { value: value?.value, ...obj }
  } else {
    return { value: keyValuePairs[id + '__' + row], ...obj }
  }
}

/* convert raw db data into format which above getGroupedData fn consumes */
export const normalizeData = (subFields, keyValuePairs) => {
  return subFields.map((it, row) => {
    return it.reduce((acc, cur) => {
      return {
        ...acc,
        ['f_' + cur.id.split('__')[0]]: getValue(
          'f_' + cur.id.split('__')[0],
          cur.data_structure,
          row + 1,
          cur.listData,
          keyValuePairs,
          cur
        ),
      }
    }, {})
  })
}

/* returns all columns in tables */
export const getAllColumns = (data) => {
  return [...data[0]].reduce((acc, cur) => {
    return cur.is_hidden ? acc : { ...acc, ['f_' + cur.id.split('__')[0]]: cur.field_template_name }
  }, {})
}
